<template>
    <div>
      <common-dialog
        ref="dialog"
        width="800px"
        :show-save-button="$permission.canEdit()"
        unit="限时活动"
        edit-title
        id-key="FlashId"
        :data="data"
        :form-rules="rules"
        @edit-opened="onEditOpened"
        @create-opened="onCreateOpened"
        :before-save="onBeforeSave"
        :save-func="api.save"
        @closed="Goods=[]"
        @close-saved="$emit('close-saved')"
      >
        <template slot="form">
          <el-row>
            <el-col :span="12">
              <el-form-item label="活动名称" prop="FlashName">
                <el-input v-model="data.FlashName" placeholder="请输入活动名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开始时间" prop="StartTime">
                <el-date-picker
                  size="mini"
                  type="datetime"
                  v-model="data.StartTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择开始时间"
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="截止时间" prop="EndTime">
                <el-date-picker
                  size="mini"
                  type="datetime"
                  v-model="data.EndTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择截止时间"
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="活动说明" prop="Remark">
                <el-input type="textarea" v-model="data.Remark" placeholder="请输入活动说明"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider>活动商品</el-divider>
          <el-table border :data="Goods" style="width: 100%" size="mini">
          <el-table-column prop="GoodsName" label="商品名称" min-width="120px" />
          <el-table-column prop="LowWholesalePrice" label="零售价格" min-width="150px">
            <template slot-scope="{row}">
              <span>价格：{{row.DistributionPrice==null?'无':row.DistributionPrice}}</span>
              <!-- <br />
              <span>价格2：{{row.RetailPrice2==null?'无':row.RetailPrice2}}</span>-->
            </template>
          </el-table-column>
          <el-table-column prop="FlashPrice" label="限时价格" min-width="150px">
            <template slot-scope="{row}">
              <el-input-number size="mini" :min="0" v-model="row.FlashPrice" @change="priceFun(row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="LimitNumber" label="参与数量" min-width="150px">
            <template slot-scope="{row}">
              <el-input-number size="mini" :min="0" v-model="row.LimitNumber" @change="priceFun(row)"/>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="right" width="80px" v-if="$permission.canEdit()&&$permission.canWrite()">
            <template slot="header">
              <i class="el-icon-circle-plus-outline add-icon" @click="add"></i>
            </template>
            <template slot-scope="{row,$index}">
              <el-button icon="el-icon-delete" type="text" @click="del(row,$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        </template>
        <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
       </template>
        <goods-dialog ref="goodsDialog" in-dialog selectable multiple @select-multiple="setGoods" />
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import goodsDialog from "@/components/goods/info/listDialog";
  
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      goodsDialog,
    },
    data() {
      return {
        data: {
        RecordId: 0,
        FlashName: "", //名称
        StartTime: null, //开始时间
        EndTime: null, //结束时间
        Remark: "", //备注
        State: 1, //状态 - 0:停用 1:正常
        FlashGoodsIds: [],
        Goods: [],
      },
        notIds:[],
        tableDel:[],
        Goods: [],
        api: require("@/api/sale/activity/flash").default,
        ggApi: require("@/api/sale/activity/flashGoods").default,
        goodsApi:require("@/api/goods/info").default,
        rules: {
          FlashName: [{ required: true, message: "活动名称不能为空" }],
          StartTime: [{ required: true, message: "开始时间不能为空" }],
          EndTime: [{ required: true, message: "结束时间不能为空" }],
        },
      };
    },
    beforeMount() {
      this.goodsApi.getGoodsId().then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.notIds = res.Data;
        }
      });
    },
    computed: {},
    methods: {
      priceFun(row){
        if (row.T !== 0) row.T = 1;
      },
      onEditOpened(data) {
        this.ggApi.list({ FlashId: data.RecordId }).then((res) => {
          this.Goods = res.Data;
        });
      },
      add() {
        if (this.data.StartTime >= this.data.EndTime){
          this.$message.warning("截止时间必须大于开始时间");
          return false;
        }        
       
        let ids = this.Goods.map((x) => x.GoodsId);
         if(this.notIds.length>0){
          ids.push(...this.notIds);
        }
        this.$refs.goodsDialog.open().then((that) => {
          that.getTree();
          that.getData({ Status: 1, NotIds: ids, PromotionType: 0 });
        });
      },
      setGoods(data) {    //点击商品选择界面的确定后触发
        console.log("data",data);
        // let goodsList = [];
        data.forEach((x) => {  //data就是选中的商品，然后循环，把商品中的名称， id等赋值给活动子表对象。x就是代表data
          let goods = {
            FlashGoodsId: 0,
            FlashId: this.data.RecordId,
            GoodsId: x.RecordId,
            GoodsName: x.GoodsName,
          //  GroupPrice: x.OriginalPrice,
          //  OriginalPrice: x.OriginalPrice,
            T:0
          };
          this.Goods.push(goods);  //然后显示到子表中
        });
               
      },
      del(row, index) {
        this.$confirm("确认删除该行数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          if (row.T !== 0) {
            row.T = 2;
            this.tableDel.push(row);
          }
          this.Goods.splice(index, 1);
          // this.subTable();
        });
      },
      onBeforeSave() {
        if (this.Goods.length == 0) {
          this.$message.warning("请添加活动商品");
          return false;
        }
        else 
        {
          let ifsave=1;  //先设置为可保存的标记
          for (let i=0;i<this.Goods.length;i++)
          {
            var goods=this.Goods[i];
            if (goods.Rate >=10)
            {
                 this.$message.warning("折扣必须小于10");
                 ifsave=0;     //有一行不符合，则赋值成不能保存标记，并退出循环
                  break;
                
            }

          }

          if (ifsave==0)
             return false;    //标记为不能保存，则返回false
       

        }
        let tb=[]
        this.Goods.forEach(e=>{
          if(e.T===0||e.T===1) {
            tb.push(e)
          }
        })
        this.data.Goods=tb
        this.data.Goods = tb.concat(this.tableDel)
        // this.data.GroupGoodsIds = this.Goods.map(
        //   (x) => x.GroupGoodsId
        // );
        return true;
      },
      onCreateOpened(){
        this.Goods=[]
        this.tableDel=[]
      },
    },
  };
  </script>